export const title = "GoodGym - Do Good, Get Fit";

export const description = [
  "We are a community of people who get fit by doing good.",
  "We run, walk, and cycle to help community organisations",
  "and isolated older people with practical tasks.",
].join(" ");

